export default [
  {
    id: 307426064,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDc0MjYwNjQ=",
    name: "angela-blog",
    full_name: "angelabauer/angela-blog",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/angela-blog",
    description: "Blog built with Flask",
    fork: false,
    url: "https://api.github.com/repos/angelabauer/angela-blog",
    forks_url: "https://api.github.com/repos/angelabauer/angela-blog/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/angela-blog/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/angela-blog/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/angela-blog/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/angela-blog/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/angela-blog/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/angela-blog/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/angela-blog/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/angela-blog/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/angela-blog/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/angela-blog/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/angela-blog/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/angela-blog/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/angela-blog/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/angela-blog/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/angela-blog/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/angela-blog/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/angela-blog/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/angela-blog/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/angela-blog/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/angela-blog/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/angela-blog/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/angela-blog/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/angela-blog/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/angela-blog/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/angela-blog/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/angela-blog/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/angela-blog/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/angela-blog/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/angela-blog/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/angela-blog/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/angela-blog/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/angela-blog/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/angela-blog/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/angela-blog/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/angela-blog/deployments",
    created_at: "2020-10-26T15:56:21Z",
    updated_at: "2021-04-22T10:35:58Z",
    pushed_at: "2020-10-27T15:33:30Z",
    git_url: "git://github.com/angelabauer/angela-blog.git",
    ssh_url: "git@github.com:angelabauer/angela-blog.git",
    clone_url: "https://github.com/angelabauer/angela-blog.git",
    svn_url: "https://github.com/angelabauer/angela-blog",
    homepage: null,
    size: 5869,
    stargazers_count: 6,
    watchers_count: 6,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 2,
    open_issues: 0,
    watchers: 6,
    default_branch: "master",
  },
  {
    id: 308324562,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDgzMjQ1NjI=",
    name: "angelabauer",
    full_name: "angelabauer/angelabauer",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/angelabauer",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/angelabauer",
    forks_url: "https://api.github.com/repos/angelabauer/angelabauer/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/angelabauer/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/angelabauer/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/angelabauer/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/angelabauer/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/angelabauer/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/angelabauer/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/angelabauer/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/angelabauer/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/angelabauer/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/angelabauer/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/angelabauer/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/angelabauer/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/angelabauer/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/angelabauer/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/angelabauer/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/angelabauer/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/angelabauer/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/angelabauer/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/angelabauer/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/angelabauer/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/angelabauer/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/angelabauer/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/angelabauer/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/angelabauer/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/angelabauer/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/angelabauer/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/angelabauer/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/angelabauer/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/angelabauer/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/angelabauer/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/angelabauer/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/angelabauer/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/angelabauer/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/angelabauer/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/angelabauer/deployments",
    created_at: "2020-10-29T12:41:10Z",
    updated_at: "2021-06-10T11:54:30Z",
    pushed_at: "2021-05-24T09:53:38Z",
    git_url: "git://github.com/angelabauer/angelabauer.git",
    ssh_url: "git@github.com:angelabauer/angelabauer.git",
    clone_url: "https://github.com/angelabauer/angelabauer.git",
    svn_url: "https://github.com/angelabauer/angelabauer",
    homepage: null,
    size: 4332,
    stargazers_count: 9,
    watchers_count: 9,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 12,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 12,
    open_issues: 0,
    watchers: 9,
    default_branch: "master",
  },
  {
    id: 153894446,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTM4OTQ0NDY=",
    name: "Bitcoin-Ticker-iOS12",
    full_name: "angelabauer/Bitcoin-Ticker-iOS12",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/Bitcoin-Ticker-iOS12",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12",
    forks_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/teams",
    hooks_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/Bitcoin-Ticker-iOS12/deployments",
    created_at: "2018-10-20T10:29:04Z",
    updated_at: "2021-03-14T06:00:50Z",
    pushed_at: "2018-10-20T10:29:11Z",
    git_url: "git://github.com/angelabauer/Bitcoin-Ticker-iOS12.git",
    ssh_url: "git@github.com:angelabauer/Bitcoin-Ticker-iOS12.git",
    clone_url: "https://github.com/angelabauer/Bitcoin-Ticker-iOS12.git",
    svn_url: "https://github.com/angelabauer/Bitcoin-Ticker-iOS12",
    homepage: null,
    size: 4457,
    stargazers_count: 6,
    watchers_count: 6,
    language: "Swift",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 6,
    default_branch: "master",
  },
  {
    id: 207838735,
    node_id: "MDEwOlJlcG9zaXRvcnkyMDc4Mzg3MzU=",
    name: "ByteCoin-iOS13-Completed",
    full_name: "angelabauer/ByteCoin-iOS13-Completed",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/ByteCoin-iOS13-Completed",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed",
    forks_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/teams",
    hooks_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/ByteCoin-iOS13-Completed/deployments",
    created_at: "2019-09-11T14:56:36Z",
    updated_at: "2021-03-14T06:00:45Z",
    pushed_at: "2019-10-05T02:19:30Z",
    git_url: "git://github.com/angelabauer/ByteCoin-iOS13-Completed.git",
    ssh_url: "git@github.com:angelabauer/ByteCoin-iOS13-Completed.git",
    clone_url: "https://github.com/angelabauer/ByteCoin-iOS13-Completed.git",
    svn_url: "https://github.com/angelabauer/ByteCoin-iOS13-Completed",
    homepage: null,
    size: 0,
    stargazers_count: 4,
    watchers_count: 4,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 300560706,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDA1NjA3MDY=",
    name: "compilebox",
    full_name: "angelabauer/compilebox",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/compilebox",
    description:
      "Compile and run user-submitted code in a docker based sandbox.",
    fork: true,
    url: "https://api.github.com/repos/angelabauer/compilebox",
    forks_url: "https://api.github.com/repos/angelabauer/compilebox/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/compilebox/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/compilebox/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/compilebox/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/compilebox/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/compilebox/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/compilebox/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/compilebox/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/compilebox/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/compilebox/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/compilebox/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/compilebox/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/compilebox/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/compilebox/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/compilebox/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/compilebox/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/compilebox/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/compilebox/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/compilebox/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/compilebox/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/compilebox/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/compilebox/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/compilebox/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/compilebox/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/compilebox/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/compilebox/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/compilebox/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/compilebox/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/compilebox/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/compilebox/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/compilebox/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/compilebox/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/compilebox/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/compilebox/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/compilebox/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/compilebox/deployments",
    created_at: "2020-10-02T09:09:52Z",
    updated_at: "2021-03-14T06:00:52Z",
    pushed_at: "2018-08-24T20:03:52Z",
    git_url: "git://github.com/angelabauer/compilebox.git",
    ssh_url: "git@github.com:angelabauer/compilebox.git",
    clone_url: "https://github.com/angelabauer/compilebox.git",
    svn_url: "https://github.com/angelabauer/compilebox",
    homepage: null,
    size: 78,
    stargazers_count: 3,
    watchers_count: 3,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 0,
    open_issues: 0,
    watchers: 3,
    default_branch: "master",
  },
  {
    id: 277862556,
    node_id: "MDEwOlJlcG9zaXRvcnkyNzc4NjI1NTY=",
    name: "COVID-19-app-iOS-BETA",
    full_name: "angelabauer/COVID-19-app-iOS-BETA",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/COVID-19-app-iOS-BETA",
    description: "Source code of the Beta of the NHS COVID-19 iOS app",
    fork: true,
    url: "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA",
    forks_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/teams",
    hooks_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/COVID-19-app-iOS-BETA/deployments",
    created_at: "2020-07-07T16:04:22Z",
    updated_at: "2021-06-01T10:59:51Z",
    pushed_at: "2020-06-26T11:23:11Z",
    git_url: "git://github.com/angelabauer/COVID-19-app-iOS-BETA.git",
    ssh_url: "git@github.com:angelabauer/COVID-19-app-iOS-BETA.git",
    clone_url: "https://github.com/angelabauer/COVID-19-app-iOS-BETA.git",
    svn_url: "https://github.com/angelabauer/COVID-19-app-iOS-BETA",
    homepage: "https://covid19.nhs.uk/",
    size: 45012,
    stargazers_count: 23,
    watchers_count: 23,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 12,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 12,
    open_issues: 0,
    watchers: 23,
    default_branch: "master",
  },
  {
    id: 180132201,
    node_id: "MDEwOlJlcG9zaXRvcnkxODAxMzIyMDE=",
    name: "current-weather",
    full_name: "angelabauer/current-weather",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/current-weather",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/current-weather",
    forks_url: "https://api.github.com/repos/angelabauer/current-weather/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/current-weather/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/current-weather/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/current-weather/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/current-weather/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/current-weather/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/current-weather/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/current-weather/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/current-weather/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/current-weather/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/current-weather/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/current-weather/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/current-weather/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/current-weather/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/current-weather/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/current-weather/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/current-weather/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/current-weather/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/current-weather/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/current-weather/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/current-weather/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/current-weather/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/current-weather/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/current-weather/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/current-weather/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/current-weather/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/current-weather/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/current-weather/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/current-weather/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/current-weather/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/current-weather/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/current-weather/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/current-weather/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/current-weather/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/current-weather/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/current-weather/deployments",
    created_at: "2019-04-08T11:12:21Z",
    updated_at: "2021-06-01T10:59:58Z",
    pushed_at: "2020-10-01T20:04:41Z",
    git_url: "git://github.com/angelabauer/current-weather.git",
    ssh_url: "git@github.com:angelabauer/current-weather.git",
    clone_url: "https://github.com/angelabauer/current-weather.git",
    svn_url: "https://github.com/angelabauer/current-weather",
    homepage: null,
    size: 4,
    stargazers_count: 11,
    watchers_count: 11,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    forks: 2,
    open_issues: 2,
    watchers: 11,
    default_branch: "master",
  },
  {
    id: 154483770,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTQ0ODM3NzA=",
    name: "cv",
    full_name: "angelabauer/cv",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/cv",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/cv",
    forks_url: "https://api.github.com/repos/angelabauer/cv/forks",
    keys_url: "https://api.github.com/repos/angelabauer/cv/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/cv/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/cv/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/cv/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/cv/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/cv/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/cv/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/cv/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/cv/tags",
    blobs_url: "https://api.github.com/repos/angelabauer/cv/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/angelabauer/cv/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/angelabauer/cv/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/angelabauer/cv/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/angelabauer/cv/statuses/{sha}",
    languages_url: "https://api.github.com/repos/angelabauer/cv/languages",
    stargazers_url: "https://api.github.com/repos/angelabauer/cv/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/cv/contributors",
    subscribers_url: "https://api.github.com/repos/angelabauer/cv/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/cv/subscription",
    commits_url: "https://api.github.com/repos/angelabauer/cv/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/cv/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/cv/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/cv/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/cv/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/cv/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/cv/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/cv/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/angelabauer/cv/downloads",
    issues_url: "https://api.github.com/repos/angelabauer/cv/issues{/number}",
    pulls_url: "https://api.github.com/repos/angelabauer/cv/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/cv/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/cv/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/angelabauer/cv/labels{/name}",
    releases_url: "https://api.github.com/repos/angelabauer/cv/releases{/id}",
    deployments_url: "https://api.github.com/repos/angelabauer/cv/deployments",
    created_at: "2018-10-24T10:40:28Z",
    updated_at: "2021-06-10T11:54:46Z",
    pushed_at: "2020-09-05T00:55:13Z",
    git_url: "git://github.com/angelabauer/cv.git",
    ssh_url: "git@github.com:angelabauer/cv.git",
    clone_url: "https://github.com/angelabauer/cv.git",
    svn_url: "https://github.com/angelabauer/cv",
    homepage: null,
    size: 20,
    stargazers_count: 41,
    watchers_count: 41,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 43,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    forks: 43,
    open_issues: 1,
    watchers: 41,
    default_branch: "master",
  },
  {
    id: 307426440,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDc0MjY0NDA=",
    name: "flask-blog",
    full_name: "angelabauer/flask-blog",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/flask-blog",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/flask-blog",
    forks_url: "https://api.github.com/repos/angelabauer/flask-blog/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/flask-blog/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/flask-blog/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/flask-blog/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/flask-blog/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/flask-blog/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/flask-blog/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/flask-blog/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/flask-blog/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/flask-blog/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/flask-blog/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/flask-blog/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/flask-blog/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/flask-blog/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/flask-blog/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/flask-blog/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/flask-blog/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/flask-blog/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/flask-blog/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/flask-blog/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/flask-blog/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/flask-blog/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/flask-blog/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/flask-blog/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/flask-blog/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/flask-blog/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/flask-blog/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/flask-blog/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/flask-blog/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/flask-blog/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/flask-blog/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/flask-blog/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/flask-blog/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/flask-blog/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/flask-blog/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/flask-blog/deployments",
    created_at: "2020-10-26T15:57:36Z",
    updated_at: "2021-04-21T14:10:03Z",
    pushed_at: "2020-10-26T15:57:47Z",
    git_url: "git://github.com/angelabauer/flask-blog.git",
    ssh_url: "git@github.com:angelabauer/flask-blog.git",
    clone_url: "https://github.com/angelabauer/flask-blog.git",
    svn_url: "https://github.com/angelabauer/flask-blog",
    homepage: null,
    size: 5867,
    stargazers_count: 6,
    watchers_count: 6,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 6,
    default_branch: "master",
  },
  {
    id: 306595607,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDY1OTU2MDc=",
    name: "Flask-Blog-Project",
    full_name: "angelabauer/Flask-Blog-Project",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/Flask-Blog-Project",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/Flask-Blog-Project",
    forks_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/teams",
    hooks_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/Flask-Blog-Project/deployments",
    created_at: "2020-10-23T09:55:41Z",
    updated_at: "2021-06-10T11:54:39Z",
    pushed_at: "2020-10-23T15:21:13Z",
    git_url: "git://github.com/angelabauer/Flask-Blog-Project.git",
    ssh_url: "git@github.com:angelabauer/Flask-Blog-Project.git",
    clone_url: "https://github.com/angelabauer/Flask-Blog-Project.git",
    svn_url: "https://github.com/angelabauer/Flask-Blog-Project",
    homepage: null,
    size: 12048,
    stargazers_count: 5,
    watchers_count: 5,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 5,
    default_branch: "master",
  },
  {
    id: 306612798,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDY2MTI3OTg=",
    name: "flask-windows-test",
    full_name: "angelabauer/flask-windows-test",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/flask-windows-test",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/flask-windows-test",
    forks_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/teams",
    hooks_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/flask-windows-test/deployments",
    created_at: "2020-10-23T11:13:59Z",
    updated_at: "2021-06-10T11:54:42Z",
    pushed_at: "2020-10-23T11:35:57Z",
    git_url: "git://github.com/angelabauer/flask-windows-test.git",
    ssh_url: "git@github.com:angelabauer/flask-windows-test.git",
    clone_url: "https://github.com/angelabauer/flask-windows-test.git",
    svn_url: "https://github.com/angelabauer/flask-windows-test",
    homepage: null,
    size: 16638,
    stargazers_count: 4,
    watchers_count: 4,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 94865338,
    node_id: "MDEwOlJlcG9zaXRvcnk5NDg2NTMzOA==",
    name: "I-Am-Poor-iOS11",
    full_name: "angelabauer/I-Am-Poor-iOS11",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/I-Am-Poor-iOS11",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11",
    forks_url: "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/I-Am-Poor-iOS11/deployments",
    created_at: "2017-06-20T08:01:02Z",
    updated_at: "2021-03-14T06:00:59Z",
    pushed_at: "2017-09-22T08:02:40Z",
    git_url: "git://github.com/angelabauer/I-Am-Poor-iOS11.git",
    ssh_url: "git@github.com:angelabauer/I-Am-Poor-iOS11.git",
    clone_url: "https://github.com/angelabauer/I-Am-Poor-iOS11.git",
    svn_url: "https://github.com/angelabauer/I-Am-Poor-iOS11",
    homepage: null,
    size: 173,
    stargazers_count: 5,
    watchers_count: 5,
    language: "Swift",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 2,
    open_issues: 0,
    watchers: 5,
    default_branch: "master",
  },
  {
    id: 44817425,
    node_id: "MDEwOlJlcG9zaXRvcnk0NDgxNzQyNQ==",
    name: "Images",
    full_name: "angelabauer/Images",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/Images",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/Images",
    forks_url: "https://api.github.com/repos/angelabauer/Images/forks",
    keys_url: "https://api.github.com/repos/angelabauer/Images/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/Images/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/Images/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/Images/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/Images/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/Images/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/Images/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/Images/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/Images/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/Images/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/Images/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/Images/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/Images/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/Images/statuses/{sha}",
    languages_url: "https://api.github.com/repos/angelabauer/Images/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/Images/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/Images/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/Images/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/Images/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/Images/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/Images/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/Images/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/Images/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/Images/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/Images/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/Images/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/Images/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/angelabauer/Images/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/Images/issues{/number}",
    pulls_url: "https://api.github.com/repos/angelabauer/Images/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/Images/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/Images/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/angelabauer/Images/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/Images/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/Images/deployments",
    created_at: "2015-10-23T14:15:20Z",
    updated_at: "2021-03-14T06:01:01Z",
    pushed_at: "2015-10-23T14:15:20Z",
    git_url: "git://github.com/angelabauer/Images.git",
    ssh_url: "git@github.com:angelabauer/Images.git",
    clone_url: "https://github.com/angelabauer/Images.git",
    svn_url: "https://github.com/angelabauer/Images",
    homepage: null,
    size: 0,
    stargazers_count: 4,
    watchers_count: 4,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 145226193,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDUyMjYxOTM=",
    name: "InspoQuotes",
    full_name: "angelabauer/InspoQuotes",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/InspoQuotes",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/InspoQuotes",
    forks_url: "https://api.github.com/repos/angelabauer/InspoQuotes/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/InspoQuotes/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/InspoQuotes/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/InspoQuotes/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/InspoQuotes/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/InspoQuotes/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/InspoQuotes/deployments",
    created_at: "2018-08-18T14:23:26Z",
    updated_at: "2021-03-14T06:00:54Z",
    pushed_at: "2018-08-18T14:23:45Z",
    git_url: "git://github.com/angelabauer/InspoQuotes.git",
    ssh_url: "git@github.com:angelabauer/InspoQuotes.git",
    clone_url: "https://github.com/angelabauer/InspoQuotes.git",
    svn_url: "https://github.com/angelabauer/InspoQuotes",
    homepage: null,
    size: 126,
    stargazers_count: 3,
    watchers_count: 3,
    language: "Swift",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 3,
    default_branch: "master",
  },
  {
    id: 306678113,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDY2NzgxMTM=",
    name: "new-blog-test",
    full_name: "angelabauer/new-blog-test",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/new-blog-test",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/new-blog-test",
    forks_url: "https://api.github.com/repos/angelabauer/new-blog-test/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/new-blog-test/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/new-blog-test/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/new-blog-test/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/new-blog-test/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/new-blog-test/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/new-blog-test/deployments",
    created_at: "2020-10-23T15:37:27Z",
    updated_at: "2021-06-10T11:54:35Z",
    pushed_at: "2020-10-23T15:37:43Z",
    git_url: "git://github.com/angelabauer/new-blog-test.git",
    ssh_url: "git@github.com:angelabauer/new-blog-test.git",
    clone_url: "https://github.com/angelabauer/new-blog-test.git",
    svn_url: "https://github.com/angelabauer/new-blog-test",
    homepage: null,
    size: 17193,
    stargazers_count: 7,
    watchers_count: 7,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 7,
    default_branch: "master",
  },
  {
    id: 306614672,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDY2MTQ2NzI=",
    name: "new-windows-test",
    full_name: "angelabauer/new-windows-test",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/new-windows-test",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/new-windows-test",
    forks_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/teams",
    hooks_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/new-windows-test/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/new-windows-test/deployments",
    created_at: "2020-10-23T11:22:35Z",
    updated_at: "2021-04-21T14:10:23Z",
    pushed_at: "2020-10-23T11:22:36Z",
    git_url: "git://github.com/angelabauer/new-windows-test.git",
    ssh_url: "git@github.com:angelabauer/new-windows-test.git",
    clone_url: "https://github.com/angelabauer/new-windows-test.git",
    svn_url: "https://github.com/angelabauer/new-windows-test",
    homepage: null,
    size: 0,
    stargazers_count: 3,
    watchers_count: 3,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 3,
    default_branch: "main",
  },
  {
    id: 300535042,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDA1MzUwNDI=",
    name: "python-coding-challenges",
    full_name: "angelabauer/python-coding-challenges",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/python-coding-challenges",
    description: "freeCodeCamp's stand-alone Python coding challenges",
    fork: true,
    url: "https://api.github.com/repos/angelabauer/python-coding-challenges",
    forks_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/teams",
    hooks_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/python-coding-challenges/deployments",
    created_at: "2020-10-02T07:24:38Z",
    updated_at: "2021-05-20T03:53:11Z",
    pushed_at: "2018-11-04T02:37:36Z",
    git_url: "git://github.com/angelabauer/python-coding-challenges.git",
    ssh_url: "git@github.com:angelabauer/python-coding-challenges.git",
    clone_url: "https://github.com/angelabauer/python-coding-challenges.git",
    svn_url: "https://github.com/angelabauer/python-coding-challenges",
    homepage: "",
    size: 1120,
    stargazers_count: 13,
    watchers_count: 13,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 12,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "bsd-3-clause",
      name: 'BSD 3-Clause "New" or "Revised" License',
      spdx_id: "BSD-3-Clause",
      url: "https://api.github.com/licenses/bsd-3-clause",
      node_id: "MDc6TGljZW5zZTU=",
    },
    forks: 12,
    open_issues: 0,
    watchers: 13,
    default_branch: "master",
  },
  {
    id: 103282055,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDMyODIwNTU=",
    name: "Story",
    full_name: "angelabauer/Story",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/Story",
    description: "My masterpiece.",
    fork: false,
    url: "https://api.github.com/repos/angelabauer/Story",
    forks_url: "https://api.github.com/repos/angelabauer/Story/forks",
    keys_url: "https://api.github.com/repos/angelabauer/Story/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/Story/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/Story/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/Story/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/Story/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/Story/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/Story/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/Story/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/Story/tags",
    blobs_url: "https://api.github.com/repos/angelabauer/Story/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/Story/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/Story/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/angelabauer/Story/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/Story/statuses/{sha}",
    languages_url: "https://api.github.com/repos/angelabauer/Story/languages",
    stargazers_url: "https://api.github.com/repos/angelabauer/Story/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/Story/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/Story/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/Story/subscription",
    commits_url: "https://api.github.com/repos/angelabauer/Story/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/Story/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/Story/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/Story/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/Story/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/Story/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/Story/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/Story/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/angelabauer/Story/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/Story/issues{/number}",
    pulls_url: "https://api.github.com/repos/angelabauer/Story/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/Story/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/Story/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/angelabauer/Story/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/Story/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/Story/deployments",
    created_at: "2017-09-12T14:36:42Z",
    updated_at: "2021-06-10T11:54:24Z",
    pushed_at: "2021-06-05T05:37:56Z",
    git_url: "git://github.com/angelabauer/Story.git",
    ssh_url: "git@github.com:angelabauer/Story.git",
    clone_url: "https://github.com/angelabauer/Story.git",
    svn_url: "https://github.com/angelabauer/Story",
    homepage: null,
    size: 1,
    stargazers_count: 27,
    watchers_count: 27,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 176,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 111,
    license: null,
    forks: 176,
    open_issues: 111,
    watchers: 27,
    default_branch: "master",
  },
  {
    id: 103408252,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDM0MDgyNTI=",
    name: "Story2",
    full_name: "angelabauer/Story2",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/Story2",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/Story2",
    forks_url: "https://api.github.com/repos/angelabauer/Story2/forks",
    keys_url: "https://api.github.com/repos/angelabauer/Story2/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/Story2/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/Story2/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/Story2/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/Story2/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/Story2/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/Story2/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/Story2/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/Story2/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/Story2/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/Story2/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/Story2/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/Story2/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/Story2/statuses/{sha}",
    languages_url: "https://api.github.com/repos/angelabauer/Story2/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/Story2/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/Story2/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/Story2/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/Story2/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/Story2/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/Story2/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/Story2/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/Story2/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/Story2/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/Story2/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/Story2/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/Story2/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/angelabauer/Story2/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/Story2/issues{/number}",
    pulls_url: "https://api.github.com/repos/angelabauer/Story2/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/Story2/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/Story2/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/angelabauer/Story2/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/Story2/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/Story2/deployments",
    created_at: "2017-09-13T14:11:44Z",
    updated_at: "2021-04-21T14:10:00Z",
    pushed_at: "2021-01-23T08:00:33Z",
    git_url: "git://github.com/angelabauer/Story2.git",
    ssh_url: "git@github.com:angelabauer/Story2.git",
    clone_url: "https://github.com/angelabauer/Story2.git",
    svn_url: "https://github.com/angelabauer/Story2",
    homepage: null,
    size: 1,
    stargazers_count: 7,
    watchers_count: 7,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 9,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    forks: 9,
    open_issues: 4,
    watchers: 7,
    default_branch: "master",
  },
  {
    id: 131838077,
    node_id: "MDEwOlJlcG9zaXRvcnkxMzE4MzgwNzc=",
    name: "test",
    full_name: "angelabauer/test",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/test",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/test",
    forks_url: "https://api.github.com/repos/angelabauer/test/forks",
    keys_url: "https://api.github.com/repos/angelabauer/test/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/test/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/test/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/test/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/test/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/test/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/test/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/test/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/test/tags",
    blobs_url: "https://api.github.com/repos/angelabauer/test/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/test/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/test/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/angelabauer/test/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/test/statuses/{sha}",
    languages_url: "https://api.github.com/repos/angelabauer/test/languages",
    stargazers_url: "https://api.github.com/repos/angelabauer/test/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/test/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/test/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/test/subscription",
    commits_url: "https://api.github.com/repos/angelabauer/test/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/test/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/test/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/test/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/test/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/test/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/test/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/test/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/angelabauer/test/downloads",
    issues_url: "https://api.github.com/repos/angelabauer/test/issues{/number}",
    pulls_url: "https://api.github.com/repos/angelabauer/test/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/test/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/test/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/angelabauer/test/labels{/name}",
    releases_url: "https://api.github.com/repos/angelabauer/test/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/test/deployments",
    created_at: "2018-05-02T10:57:31Z",
    updated_at: "2021-03-14T06:00:56Z",
    pushed_at: "2018-05-03T10:05:01Z",
    git_url: "git://github.com/angelabauer/test.git",
    ssh_url: "git@github.com:angelabauer/test.git",
    clone_url: "https://github.com/angelabauer/test.git",
    svn_url: "https://github.com/angelabauer/test",
    homepage: null,
    size: 5,
    stargazers_count: 4,
    watchers_count: 4,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 110544694,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTA1NDQ2OTQ=",
    name: "Test-Checklist",
    full_name: "angelabauer/Test-Checklist",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/Test-Checklist",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/Test-Checklist",
    forks_url: "https://api.github.com/repos/angelabauer/Test-Checklist/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/Test-Checklist/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/Test-Checklist/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/Test-Checklist/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/Test-Checklist/deployments",
    created_at: "2017-11-13T12:20:01Z",
    updated_at: "2021-03-14T06:00:58Z",
    pushed_at: "2017-11-13T12:20:28Z",
    git_url: "git://github.com/angelabauer/Test-Checklist.git",
    ssh_url: "git@github.com:angelabauer/Test-Checklist.git",
    clone_url: "https://github.com/angelabauer/Test-Checklist.git",
    svn_url: "https://github.com/angelabauer/Test-Checklist",
    homepage: null,
    size: 9,
    stargazers_count: 4,
    watchers_count: 4,
    language: "Swift",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 2,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 300242970,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDAyNDI5NzA=",
    name: "test-exercise",
    full_name: "angelabauer/test-exercise",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/test-exercise",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/test-exercise",
    forks_url: "https://api.github.com/repos/angelabauer/test-exercise/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/test-exercise/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/test-exercise/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/test-exercise/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/test-exercise/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/test-exercise/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/test-exercise/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/test-exercise/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/test-exercise/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/test-exercise/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/test-exercise/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/test-exercise/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/test-exercise/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/test-exercise/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/test-exercise/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/test-exercise/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/test-exercise/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/test-exercise/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/test-exercise/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/test-exercise/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/test-exercise/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/test-exercise/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/test-exercise/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/test-exercise/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/test-exercise/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/test-exercise/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/test-exercise/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/test-exercise/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/test-exercise/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/test-exercise/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/test-exercise/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/test-exercise/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/test-exercise/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/test-exercise/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/test-exercise/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/test-exercise/deployments",
    created_at: "2020-10-01T10:44:11Z",
    updated_at: "2021-06-10T11:54:45Z",
    pushed_at: "2020-10-01T10:54:25Z",
    git_url: "git://github.com/angelabauer/test-exercise.git",
    ssh_url: "git@github.com:angelabauer/test-exercise.git",
    clone_url: "https://github.com/angelabauer/test-exercise.git",
    svn_url: "https://github.com/angelabauer/test-exercise",
    homepage: null,
    size: 2,
    stargazers_count: 5,
    watchers_count: 5,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 5,
    default_branch: "master",
  },
  {
    id: 154477604,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTQ0Nzc2MDQ=",
    name: "test-github-pages",
    full_name: "angelabauer/test-github-pages",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/test-github-pages",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/test-github-pages",
    forks_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/teams",
    hooks_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/test-github-pages/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/test-github-pages/deployments",
    created_at: "2018-10-24T09:51:38Z",
    updated_at: "2021-03-14T06:00:48Z",
    pushed_at: "2018-10-24T09:52:26Z",
    git_url: "git://github.com/angelabauer/test-github-pages.git",
    ssh_url: "git@github.com:angelabauer/test-github-pages.git",
    clone_url: "https://github.com/angelabauer/test-github-pages.git",
    svn_url: "https://github.com/angelabauer/test-github-pages",
    homepage: null,
    size: 19,
    stargazers_count: 5,
    watchers_count: 5,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 5,
    default_branch: "master",
  },
  {
    id: 154477526,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTQ0Nzc1MjY=",
    name: "test-publish",
    full_name: "angelabauer/test-publish",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/test-publish",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/test-publish",
    forks_url: "https://api.github.com/repos/angelabauer/test-publish/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/test-publish/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/test-publish/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/test-publish/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/test-publish/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/test-publish/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/test-publish/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/test-publish/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/test-publish/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/test-publish/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/test-publish/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/test-publish/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/test-publish/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/test-publish/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/test-publish/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/test-publish/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/test-publish/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/test-publish/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/test-publish/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/test-publish/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/test-publish/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/test-publish/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/test-publish/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/test-publish/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/test-publish/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/test-publish/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/test-publish/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/test-publish/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/test-publish/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/test-publish/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/test-publish/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/test-publish/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/test-publish/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/test-publish/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/test-publish/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/test-publish/deployments",
    created_at: "2018-10-24T09:51:04Z",
    updated_at: "2021-03-14T06:00:50Z",
    pushed_at: "2018-10-24T09:51:05Z",
    git_url: "git://github.com/angelabauer/test-publish.git",
    ssh_url: "git@github.com:angelabauer/test-publish.git",
    clone_url: "https://github.com/angelabauer/test-publish.git",
    svn_url: "https://github.com/angelabauer/test-publish",
    homepage: null,
    size: 0,
    stargazers_count: 6,
    watchers_count: 6,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 6,
    default_branch: "master",
  },
  {
    id: 306621171,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDY2MjExNzE=",
    name: "testing",
    full_name: "angelabauer/testing",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/testing",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/testing",
    forks_url: "https://api.github.com/repos/angelabauer/testing/forks",
    keys_url: "https://api.github.com/repos/angelabauer/testing/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/testing/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/testing/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/testing/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/testing/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/testing/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/testing/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/testing/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/testing/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/testing/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/testing/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/testing/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/testing/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/testing/statuses/{sha}",
    languages_url: "https://api.github.com/repos/angelabauer/testing/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/testing/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/testing/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/testing/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/testing/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/testing/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/testing/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/testing/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/testing/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/testing/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/testing/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/testing/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/testing/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/angelabauer/testing/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/testing/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/testing/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/testing/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/testing/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/testing/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/testing/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/testing/deployments",
    created_at: "2020-10-23T11:52:11Z",
    updated_at: "2021-04-21T14:10:14Z",
    pushed_at: "2020-10-23T11:53:48Z",
    git_url: "git://github.com/angelabauer/testing.git",
    ssh_url: "git@github.com:angelabauer/testing.git",
    clone_url: "https://github.com/angelabauer/testing.git",
    svn_url: "https://github.com/angelabauer/testing",
    homepage: null,
    size: 1,
    stargazers_count: 4,
    watchers_count: 4,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 4,
    default_branch: "main",
  },
  {
    id: 193070756,
    node_id: "MDEwOlJlcG9zaXRvcnkxOTMwNzA3NTY=",
    name: "TFJS",
    full_name: "angelabauer/TFJS",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/TFJS",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/TFJS",
    forks_url: "https://api.github.com/repos/angelabauer/TFJS/forks",
    keys_url: "https://api.github.com/repos/angelabauer/TFJS/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/TFJS/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/TFJS/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/TFJS/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/TFJS/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/TFJS/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/TFJS/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/TFJS/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/TFJS/tags",
    blobs_url: "https://api.github.com/repos/angelabauer/TFJS/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/TFJS/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/TFJS/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/angelabauer/TFJS/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/TFJS/statuses/{sha}",
    languages_url: "https://api.github.com/repos/angelabauer/TFJS/languages",
    stargazers_url: "https://api.github.com/repos/angelabauer/TFJS/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/TFJS/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/TFJS/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/TFJS/subscription",
    commits_url: "https://api.github.com/repos/angelabauer/TFJS/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/TFJS/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/TFJS/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/TFJS/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/TFJS/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/TFJS/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/TFJS/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/TFJS/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/angelabauer/TFJS/downloads",
    issues_url: "https://api.github.com/repos/angelabauer/TFJS/issues{/number}",
    pulls_url: "https://api.github.com/repos/angelabauer/TFJS/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/TFJS/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/TFJS/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/angelabauer/TFJS/labels{/name}",
    releases_url: "https://api.github.com/repos/angelabauer/TFJS/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/TFJS/deployments",
    created_at: "2019-06-21T09:30:19Z",
    updated_at: "2021-03-14T06:00:46Z",
    pushed_at: "2019-06-21T09:31:16Z",
    git_url: "git://github.com/angelabauer/TFJS.git",
    ssh_url: "git@github.com:angelabauer/TFJS.git",
    clone_url: "https://github.com/angelabauer/TFJS.git",
    svn_url: "https://github.com/angelabauer/TFJS",
    homepage: null,
    size: 1585,
    stargazers_count: 5,
    watchers_count: 5,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 5,
    default_branch: "master",
  },
  {
    id: 288687375,
    node_id: "MDEwOlJlcG9zaXRvcnkyODg2ODczNzU=",
    name: "the-internet",
    full_name: "angelabauer/the-internet",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/the-internet",
    description:
      "An example application that captures prominent and ugly functionality found on the web. Perfect for writing automated acceptance tests against.",
    fork: true,
    url: "https://api.github.com/repos/angelabauer/the-internet",
    forks_url: "https://api.github.com/repos/angelabauer/the-internet/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/the-internet/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/the-internet/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/the-internet/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/the-internet/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/the-internet/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/the-internet/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/the-internet/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/the-internet/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/the-internet/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/the-internet/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/the-internet/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/the-internet/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/the-internet/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/the-internet/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/the-internet/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/the-internet/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/the-internet/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/the-internet/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/the-internet/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/the-internet/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/the-internet/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/the-internet/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/the-internet/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/the-internet/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/the-internet/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/the-internet/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/the-internet/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/the-internet/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/the-internet/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/the-internet/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/the-internet/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/the-internet/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/the-internet/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/the-internet/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/the-internet/deployments",
    created_at: "2020-08-19T09:17:58Z",
    updated_at: "2021-03-14T06:00:40Z",
    pushed_at: "2020-08-14T02:27:44Z",
    git_url: "git://github.com/angelabauer/the-internet.git",
    ssh_url: "git@github.com:angelabauer/the-internet.git",
    clone_url: "https://github.com/angelabauer/the-internet.git",
    svn_url: "https://github.com/angelabauer/the-internet",
    homepage: "http://the-internet.herokuapp.com",
    size: 33311,
    stargazers_count: 2,
    watchers_count: 2,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 2,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 2,
    open_issues: 0,
    watchers: 2,
    default_branch: "master",
  },
  {
    id: 102617067,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDI2MTcwNjc=",
    name: "ToodleDo",
    full_name: "angelabauer/ToodleDo",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/ToodleDo",
    description: "ToDo List App",
    fork: false,
    url: "https://api.github.com/repos/angelabauer/ToodleDo",
    forks_url: "https://api.github.com/repos/angelabauer/ToodleDo/forks",
    keys_url: "https://api.github.com/repos/angelabauer/ToodleDo/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/ToodleDo/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/ToodleDo/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/ToodleDo/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/ToodleDo/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/ToodleDo/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/ToodleDo/deployments",
    created_at: "2017-09-06T14:13:48Z",
    updated_at: "2021-03-14T06:01:01Z",
    pushed_at: "2017-09-06T14:52:30Z",
    git_url: "git://github.com/angelabauer/ToodleDo.git",
    ssh_url: "git@github.com:angelabauer/ToodleDo.git",
    clone_url: "https://github.com/angelabauer/ToodleDo.git",
    svn_url: "https://github.com/angelabauer/ToodleDo",
    homepage: null,
    size: 12,
    stargazers_count: 4,
    watchers_count: 4,
    language: "Swift",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 141299086,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDEyOTkwODY=",
    name: "Twittermenti-iOS12",
    full_name: "angelabauer/Twittermenti-iOS12",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/Twittermenti-iOS12",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/Twittermenti-iOS12",
    forks_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/forks",
    keys_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/teams",
    hooks_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/tags",
    blobs_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/languages",
    stargazers_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/subscription",
    commits_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/Twittermenti-iOS12/deployments",
    created_at: "2018-07-17T14:12:06Z",
    updated_at: "2021-03-14T06:00:55Z",
    pushed_at: "2018-07-17T14:12:11Z",
    git_url: "git://github.com/angelabauer/Twittermenti-iOS12.git",
    ssh_url: "git@github.com:angelabauer/Twittermenti-iOS12.git",
    clone_url: "https://github.com/angelabauer/Twittermenti-iOS12.git",
    svn_url: "https://github.com/angelabauer/Twittermenti-iOS12",
    homepage: null,
    size: 8,
    stargazers_count: 3,
    watchers_count: 3,
    language: "Swift",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 3,
    default_branch: "master",
  },
  {
    id: 103416816,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDM0MTY4MTY=",
    name: "Udder",
    full_name: "angelabauer/Udder",
    private: false,
    owner: {
      login: "angelabauer",
      id: 8798027,
      node_id: "MDQ6VXNlcjg3OTgwMjc=",
      avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/angelabauer",
      html_url: "https://github.com/angelabauer",
      followers_url: "https://api.github.com/users/angelabauer/followers",
      following_url:
        "https://api.github.com/users/angelabauer/following{/other_user}",
      gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/angelabauer/subscriptions",
      organizations_url: "https://api.github.com/users/angelabauer/orgs",
      repos_url: "https://api.github.com/users/angelabauer/repos",
      events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/angelabauer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/angelabauer/Udder",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/angelabauer/Udder",
    forks_url: "https://api.github.com/repos/angelabauer/Udder/forks",
    keys_url: "https://api.github.com/repos/angelabauer/Udder/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/angelabauer/Udder/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/angelabauer/Udder/teams",
    hooks_url: "https://api.github.com/repos/angelabauer/Udder/hooks",
    issue_events_url:
      "https://api.github.com/repos/angelabauer/Udder/issues/events{/number}",
    events_url: "https://api.github.com/repos/angelabauer/Udder/events",
    assignees_url:
      "https://api.github.com/repos/angelabauer/Udder/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/angelabauer/Udder/branches{/branch}",
    tags_url: "https://api.github.com/repos/angelabauer/Udder/tags",
    blobs_url: "https://api.github.com/repos/angelabauer/Udder/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/angelabauer/Udder/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/angelabauer/Udder/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/angelabauer/Udder/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/angelabauer/Udder/statuses/{sha}",
    languages_url: "https://api.github.com/repos/angelabauer/Udder/languages",
    stargazers_url: "https://api.github.com/repos/angelabauer/Udder/stargazers",
    contributors_url:
      "https://api.github.com/repos/angelabauer/Udder/contributors",
    subscribers_url:
      "https://api.github.com/repos/angelabauer/Udder/subscribers",
    subscription_url:
      "https://api.github.com/repos/angelabauer/Udder/subscription",
    commits_url: "https://api.github.com/repos/angelabauer/Udder/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/angelabauer/Udder/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/angelabauer/Udder/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/angelabauer/Udder/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/angelabauer/Udder/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/angelabauer/Udder/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/angelabauer/Udder/merges",
    archive_url:
      "https://api.github.com/repos/angelabauer/Udder/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/angelabauer/Udder/downloads",
    issues_url:
      "https://api.github.com/repos/angelabauer/Udder/issues{/number}",
    pulls_url: "https://api.github.com/repos/angelabauer/Udder/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/angelabauer/Udder/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/angelabauer/Udder/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/angelabauer/Udder/labels{/name}",
    releases_url:
      "https://api.github.com/repos/angelabauer/Udder/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/angelabauer/Udder/deployments",
    created_at: "2017-09-13T15:24:22Z",
    updated_at: "2021-03-14T06:00:43Z",
    pushed_at: "2020-05-02T10:35:15Z",
    git_url: "git://github.com/angelabauer/Udder.git",
    ssh_url: "git@github.com:angelabauer/Udder.git",
    clone_url: "https://github.com/angelabauer/Udder.git",
    svn_url: "https://github.com/angelabauer/Udder",
    homepage: null,
    size: 244,
    stargazers_count: 3,
    watchers_count: 3,
    language: "Swift",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    forks: 1,
    open_issues: 1,
    watchers: 3,
    default_branch: "master",
  },
];
